import React from "react";

export const SitePaused = () => {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#050505] px-6 text-white">
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.03),rgba(0,0,0,0.92))]" />
      <div
        className="absolute inset-0 opacity-[0.035]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.7) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />

      <section className="relative z-10 w-full max-w-2xl border border-white/10 bg-[#0b0b0b]/92 p-7 shadow-[0_28px_100px_-54px_rgba(0,0,0,0.9)] sm:p-10">
        <div className="flex items-center justify-between gap-4 border-b border-white/10 pb-5">
          <div>
            <p className="text-[11px] uppercase tracking-[0.34em] text-white/42">
              Server status
            </p>
            <h1 className="mt-3 font-serif text-4xl font-light leading-none text-white sm:text-5xl">
              503
            </h1>
          </div>
          <div className="rounded-full border border-red-500/20 bg-red-500/8 px-4 py-2 text-[10px] uppercase tracking-[0.24em] text-red-200/80">
            Service error
          </div>
        </div>

        <h2 className="mt-8 font-serif text-3xl font-light leading-tight text-white sm:text-4xl">
          Service temporarily unavailable.
        </h2>
        <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-white/56">
          The requested website is currently unable to complete the request. Please try again later.
        </p>

        <div className="mt-8 grid gap-3 border border-white/10 bg-black/32 p-4 text-sm text-white/48">
          <div className="flex items-center justify-between gap-4">
            <span>Request status</span>
            <span className="font-mono text-white/72">FAILED</span>
          </div>
          <div className="flex items-center justify-between gap-4">
            <span>Error code</span>
            <span className="font-mono text-white/72">HTTP 503</span>
          </div>
          <div className="flex items-center justify-between gap-4">
            <span>Retry window</span>
            <span className="font-mono text-white/72">Later</span>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SitePaused;
